import { MainV3ApiBase } from './base';
import { UserAddress } from '../types/userAddresses';

export const userAddressesApi = {
  base() {
    return MainV3ApiBase.appendPath('users/current/address');
  },
  updateAddress(formData: UserAddress): Promise<void> {
    return this.base().put(formData);
  },
  findAddress(): Promise<UserAddress> {
    return this.base().get();
  },
};
